// API 서버 URL 설정
export const getApiServerUrl = (): string => {
  // 환경변수가 설정되어 있으면 사용, 없으면 기본값 사용
  return process.env.REACT_APP_API_SERVER_URL || 'http://localhost:5001/api';
};

// 정적 파일 서버 URL 설정
export const getStaticServerUrl = (): string => {
  // 환경변수가 설정되어 있으면 사용, 없으면 기본값 사용
  return process.env.REACT_APP_STATIC_SERVER_URL || 'http://localhost:5001';
};

// 정적 파일 URL 생성 함수
export const getStaticFileUrl = (path: string): string => {
  const serverUrl = getStaticServerUrl();
  
  // path가 이미 http로 시작하면 그대로 반환
  if (path.startsWith('http')) {
    return path;
  }
  // path가 /로 시작하면 서버 URL과 결합
  if (path.startsWith('/')) {
    const fullUrl = `${serverUrl}${path}`;
    return fullUrl;
  }
  // 그 외의 경우 서버 URL + / + path
  const fullUrl = `${serverUrl}/${path}`;
  return fullUrl;
}; 